<template>
  <div :key="keyForm">
    <div class="mb-5" v-for="form in formularioDinamico" :key="form.id">
      
        <h2 class="form-title">{{ form.titulo }}</h2>

        <div :class="`${ form.col || 'col-xs-12'}`">

          <div class="row" v-for="(linha, i) in agrupadoPorLinha(form)" :key="i">
            <template v-for="(listaDeCampos, index) in linha">

              <TextInputComponent
                v-if="
                  listaDeCampos.type != 'hidden' &&
                  (listaDeCampos.type == 'text' ||
                  listaDeCampos.type == 'url' ||
                  listaDeCampos.type == 'number' ||
                  listaDeCampos.type == 'textarea') &&
                  verificadorCondicional(listaDeCampos.show, listaDeCampos) &&
                  handleRegrasDadosExternos(listaDeCampos)
                "
                :name="listaDeCampos.name"
                :type="listaDeCampos.type"
                :label="listaDeCampos.label"
                :key="`${listaDeCampos.type}_${listaDeCampos.name}`"
                v-model="values[listaDeCampos.name]"
                :help="listaDeCampos.desc_ajuda"
                :class="`${listaDeCampos.col} margin-top-7 input-padrao-formulate`"
                stylized
                rows="3"
                dense
                readonly
                disabled
              />

              <ComboboxInputComponent
                v-else-if="
                  listaDeCampos.type == 'select' &&
                  verificadorCondicional(listaDeCampos.show, listaDeCampos) &&
                  handleRegrasDadosExternos(listaDeCampos)
                "
                :name="listaDeCampos.name"
                :type="listaDeCampos.type"
                :label="listaDeCampos.label"
                :options="listaDeCampos.options"
                :class="`${listaDeCampos.col} margin-top-7 input-padrao-formulate select-readonly`"
                :key="`select_${listaDeCampos.name}_${index}`"
                v-model="values[listaDeCampos.name]"
                dense
                readonly
              ></ComboboxInputComponent>

              <RadioInputComponent
                v-else-if="
                  listaDeCampos.type == 'radio' &&
                  verificadorCondicional(listaDeCampos.show, listaDeCampos) &&
                  handleRegrasDadosExternos(listaDeCampos)
                "
                :name="listaDeCampos.name"
                :type="listaDeCampos.type"
                :label="`${listaDeCampos.label}`"
                :options="listaDeCampos.options"
                :class="`${listaDeCampos.col} margin-top-7 input-padrao-formulate`"
                :key="`radio_${listaDeCampos.name}_${index}`"
                v-model="values[listaDeCampos.name]"
                :desc_ajuda="listaDeCampos.desc_ajuda"
                disabled
              ></RadioInputComponent>

              <DateInputComponent
                v-else-if="
                  listaDeCampos.type == 'date' ||
                  listaDeCampos.type == 'time' ||
                  listaDeCampos.type == 'datetime-local' &&
                  verificadorCondicional(listaDeCampos.show, listaDeCampos) &&
                  handleRegrasDadosExternos(listaDeCampos)
                "
                :name="listaDeCampos.name"
                :type="listaDeCampos.type"
                :label="listaDeCampos.label"
                :class="listaDeCampos.col"
                :key="`date_${listaDeCampos.name}_${index}`"
                v-model="values[listaDeCampos.name]"
                readonly
              />

              <AutocompleteComponent
                v-else-if="
                  listaDeCampos.type == 'autocomplete' &&
                  verificadorCondicional(listaDeCampos.show, listaDeCampos) &&
                  handleRegrasDadosExternos(listaDeCampos)
                "
                :col="listaDeCampos.col"
                :label="listaDeCampos.label"
                :name="listaDeCampos.name"
                :key="`autocomplete_${listaDeCampos.name}_${index}`"
                :items="listaDeCampos.options"
                :tipo_banco_dados="listaDeCampos.tipo_BD"
                :campo_tabela="listaDeCampos.campo_tabela"
                :campo_model="listaDeCampos.campo_model"
                :route_sugestoes="listaDeCampos.route_sugestoes"
                v-model="values[listaDeCampos.name]"
                :desc_ajuda="listaDeCampos.desc_ajuda"
                disabled
                readonly
              />

            </template>
          </div>
        </div>
    </div>
  </div>
</template>

<script>
import TextInputComponent from './RenderizacaoFormularioDinamicoComponent/components/TextInputComponent.vue';
import RadioInputComponent from './RenderizacaoFormularioDinamicoComponent/components/RadioInputComponent.vue';
import ComboboxInputComponent from './RenderizacaoFormularioDinamicoComponent/components/ComboboxInputComponent.vue';
import DateInputComponent from './RenderizacaoFormularioDinamicoComponent/components/DateInputComponent.vue';
import AutocompleteComponent from './RenderizacaoFormularioDinamicoComponent/components/AutocompleteComponent.vue';
import moment from 'moment';

import { mapActions, mapGetters } from 'vuex';

export default {
  name: "ReadonlyRenderizacaoFormularioDinamicoComponent",

  components: {
    TextInputComponent,
    RadioInputComponent,
    ComboboxInputComponent,
    DateInputComponent,
    AutocompleteComponent
  },

  props: {
    arrayFormId: {
      type: [Array, Number],
      required: true,
      default: undefined
    },

    dadosExternos: {
      type: [Boolean, Object],
      required: false,
      default: false
    },

    formValues: {
      type: Object,
      required: false,
      default: () => ({})
    }
  },

  data () {
    return {
      values: {},
      keyForm: '',
    }
  },

  async created () {
    if (this.$props.arrayFormId && this.$props.arrayFormId.length < 2) {
      await this.$props.arrayFormId.forEach(async form => {
        await this.recuperarFormularioDinamicoPorId({ id: form.ctrl_formulario_dinamico_id })
        await this.initComponentData()
      }) 
    } else {
      await this.recuperarListaDeFormulariosDinamicoPorId(this.$props.arrayFormId)
      await this.initComponentData()
    }
  },

  async mounted () {
    this.keyForm = true
  },

  computed: {
    ...mapGetters('ctrlFormularioDinamico', [
      'formularioDinamico',
      'loadingFormularioDinamico'
    ]),

    form () {
      if (this.formularioDinamico) {
        return [...this.formularioDinamico]
      }

      return []
    },
  },

  methods: {
    ...mapActions('ctrlFormularioDinamico', [
      'recuperarListaDeFormulariosDinamicoPorId',
      'recuperarFormularioDinamicoPorId',
    ]),

    async initComponentData () {
      await this.setarVariaveisDoFormulario()
      this.setarVariaveisMinimizado()
    },

    agrupadoPorLinha(form) {
      const resultado = {};

      if (form && Object.keys(form).length) {
        form.corpo.forEach(obj => {
          if (!resultado[obj.linha]) {
            resultado[obj.linha] = []
          }
          resultado[obj.linha].push(obj);
        })
      }

      return Object.values(resultado);
    },

    setarVariaveisDoFormulario() {
      if (this.formularioDinamico && this.formularioDinamico.length) {
        this.formularioDinamico.forEach(form => {
          if (form.corpo && form.corpo.length) {
            form.corpo.forEach(campo => {
              if (this.$props.formValues && this.$props.formValues[campo.name]) {
                this.values[campo.name] = this.$props.formValues[campo.name]
              } else if (this.$props.dadosExternos && this.$props.dadosExternos[campo.name]) {
                this.values[campo.name] = this.$props.dadosExternos[campo.name]
              } else if (campo.value) {
                this.values[campo.name] = campo.value
              }
            })
          }
        })
      }
    },

    setarVariaveisMinimizado() {
      if (this.formularioDinamico && this.formularioDinamico.length) {
        this.formularioDinamico.forEach(form => {
          if (form.corpo && form.corpo.length) {
            form.corpo.forEach(campo => {
              if (campo.type === 'date' && this.values[campo.name]) {
                this.values[campo.name] = moment(this.values[campo.name]).format('YYYY-MM-DD')
              }
            })
          }
        })
      }
    },

    verificadorCondicional(condicional) {
      // Se não tem valor ou é nulo, retorna true (mostra o campo)
      if (condicional === null || condicional === undefined) {
        return true
      }
      
      // Se já é booleano, retorna direto
      if (typeof condicional === 'boolean') {
        return condicional
      }
      
      // Se é string vazia, retorna true
      if (condicional === '') {
        return true
      }

      // Se é string, tenta avaliar como expressão
      if (typeof condicional === 'string') {
        try {
          const funcao = new Function('values', `return ${condicional}`)
          return funcao(this.values)
        } catch (error) {
          console.error('Erro ao avaliar condicional:', error)
          return true
        }
      }
      
      // Para outros tipos, converte para booleano
      return !!condicional
    },

    handleRegrasDadosExternos(campo) {
      if (this.$props.dadosExternos && campo.regras_dados_externos) {
        try {
          const regra = new Function('dadosExternos', `return ${campo.regras_dados_externos}`)
          return regra(this.$props.dadosExternos)
        } catch (error) {
          console.error('Erro ao avaliar regra dados externos:', error)
          return true
        }
      }
      return true
    },
  },

  watch: {
    formValues: {
      handler(newVal) {
        if (newVal) {
          this.values = { ...this.values, ...newVal }
        }
      },
      deep: true
    }
  }
}
</script>

<style scoped>
.form-title {
  font-size: 1.5rem;
  font-weight: 600;
  margin-bottom: 1rem;
  color: #333;
}

.select-readonly {
  pointer-events: none;
  opacity: 0.7;
}

.input-padrao-formulate >>> input:disabled,
.input-padrao-formulate >>> textarea:disabled {
  background-color: #f5f5f5;
  cursor: not-allowed;
}
</style>
